module.exports = __webpack_public_path__ + "img/file-not-found.fee0bde4.svg";